import localforage from "localforage";
import { GameData } from "../Types";
import { Language, ObjectiveType } from "../Constants";

class _SaveLoadManager {


    private _gameData: GameData;
    public get GameData() {
        return this._gameData;
    }

    private _key: string;


    init(key: string) {
        this._key = key;

        //@ts-ignore
        window.snapshot = () => {
            console.log(this._gameData);
        }

        //@ts-ignore
        window.overwrite = (data: GameData) => {
            this._gameData = data;
            this.save();
        }
    }

    async save(): Promise<void> {
        await localforage.setItem(this._key, this._gameData);
    }

    async load() {
        this._gameData = {
            version: "0.1",
            language: Language.en,
            firstTime: true,
            coins: 0,
            farms: [],
            gameProgressNames: [],
            objectives: {
                maxAtATime: 1,
                objectives: [],
                active: false,
                completed: 0,
                generated: 0,
            },
            muted: false,
        };

        const gd = await localforage.getItem<GameData>(this._key);
        if (gd) {
            this._gameData.version = gd.version;
            this._gameData.farms = gd.farms;
            this._gameData.firstTime = gd.firstTime;
            this._gameData.coins = gd.coins;
            this._gameData.gameProgressNames = [...gd.gameProgressNames];
            this._gameData.objectives = { ...this._gameData.objectives, ...gd.objectives };

            //Remove multiple objectives of buy farm and only keep single
            while (this._gameData.objectives.objectives.filter(o => o.type === ObjectiveType.BUY_FARM_2).length > 1) {
                const index = this._gameData.objectives.objectives.findIndex(o => o.type === ObjectiveType.BUY_FARM_2);
                this._gameData.objectives.objectives.splice(index, 1);
            }

            this._gameData.muted = gd.muted;
        }
    }
}

export const SaveLoadManager = new _SaveLoadManager();
